// @generated by scripts/gen-modules.mjs
import { RouteObject, Navigate } from 'react-router-dom';
import { ManagementRoutes } from './modules/management';
import { AdvancedRoutes } from './modules/advanced';
import { TimeRoutes } from './modules/time';
import { TimeAdvancedRoutes } from './modules/time-advanced';
import { AccountingRoutes } from './modules/accounting';
import { CollaborationRoutes } from './modules/collaboration';
import { DeliverablesRoutes } from './modules/deliverables';
import { ResourcesRoutes } from './modules/resources';

export const projectsRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="management/projects" replace /> },
  ManagementRoutes,
  AdvancedRoutes,
  TimeRoutes,
  TimeAdvancedRoutes,
  AccountingRoutes,
  CollaborationRoutes,
  DeliverablesRoutes,
  ResourcesRoutes,
];

export default projectsRoutes;
